import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileSpreadsheetFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15 18h6v2h-6zm-4 0h2v2h-2zm0 4h2v2h-2z" />
    <path d="M18 12a1 1 0 0 1-1-1V2H7a2.006 2.006 0 0 0-2 2v24a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V12Zm5 12.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 9 24.5v-9a1.5 1.5 0 0 1 1.5-1.5h11a1.5 1.5 0 0 1 1.5 1.5Z" />
    <path d="M15 22h6v2h-6zM26 8.59l-.29-.3-5-5-.3-.29A3.44 3.44 0 0 0 19 2.19V10h7.81A3.44 3.44 0 0 0 26 8.59" />
  </svg>
);
const ForwardRef = forwardRef(IconFileSpreadsheetFilledSVG);
ForwardRef.displayName = "IconFileSpreadsheetFilled";
export { ForwardRef as IconFileSpreadsheetFilled };
